<template>
  <div class="container boxShadow">
    <h5>预约信息</h5>
    <div class="cont">
      <h6>您将预约 <span>{{dataFormat}}</span> 的{{data.type_name}}，注意事项如下:</h6>
      <section>
        <div class="field">
          <p>报名类型：<span>*</span></p>
          <div style="1px solid #cfcfcf">
            <!-- <el-select v-model="user.sign_type" placeholder="请选择您的报名类型" @change="selectType">
              <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select> -->
            <el-radio-group v-model="user.type" @change="selectType">
              <el-radio v-for="item in options2" :key="item.value" :label="item.value" :value="item.value">{{item.label}}</el-radio>
            </el-radio-group>
            <!--  1 别人 0 自己 -->
          </div>
        </div>
        <div class="field">
          <p>姓名：<span>*</span></p>
          <input type="text" placeholder="请输入真实姓名" :disabled="disabled" v-model="user.name">
        </div>
        <div class="field">
          <p>身份证号：<span>*</span></p>
          <input type="text" placeholder="请输入身份证号" :disabled="disabled" v-model="user.idcard">
        </div>
        <div class="field">
          <p>手机号：<span>*</span></p>
          <input type="number" placeholder="请输入您的手机号" v-model="user.tel">
        </div>
        <div class="field">
          <p>预约人数：<span>*</span></p>
          <input type="number" placeholder="请输入预约人数" v-model="num">
        </div>
        <div class="field">
          <p>团队介绍：<span>*</span></p>
          <textarea name="" id="" v-model="user.team_desc"></textarea>
        </div>
        <div class="field">
          <p>团队照片：<span>*</span></p>
          <div class="idcard">
            <p>
              <input id="i1" type="file" accept="image/*" ref="file" name="i1" @change="upload($event,'team')">
              <a v-if="!user.team_pic">+</a>
              <img :src="user.team_pic" alt="" v-if="!!user.team_pic">
            </p>
          </div>
        </div>
        <!--  <div class="field" v-if="uploadFlag == 0 || user.type == 1">
          <p>上传身份证：<span>*</span></p>
          <div class="idcard">
            <p>
              <input id="i2" name="i2" type="file" accept="image/*" ref="file" @change="upload($event,'front')">
              <a v-if="!user.idcard_front">身份证正面</a>
              <img :src="user.idcard_front" alt="" v-if="!!user.idcard_front">
            </p>
            <p>
                            <input id="i3" name="i3" type="file" accept="image/*" ref="file" @change="upload($event,'backend')">
                            <a v-if="!user.idcard_reverse">身份证反面</a>
                            <img :src="user.idcard_reverse" alt="" v-if="!!user.idcard_reverse">
                        </p>
          </div>

        </div> -->
        <div class="btn btn-primary" @click="submit">预约</div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['ajax'],
  data() {
    return {
      data: '',
      user: {},
      name: '',
      num: '',
      options2: [
        {
          label: '自己报名',
          value: 0
        }, {
          label: '给别人报名',
          value: 1
        }
      ],
      disabled: false,
    };
  },
  computed: {
    dataFormat() {
      if (this.data) {
        let date = new Date(this.data.date)
        let arr = this.data.date.split('-')
        let week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
        return `${arr[0]}年${arr[1]}月${arr[2]}日 ${week[date.getDay()]} ${this.data.start}-${this.data.end}`
      }
    }
  },
  mounted() {
    let _this = this
    this.ajax(`/api/reserve/info?id=${this.$route.query.id}`, 'get', '', res => {
      this.data = res.data.data.data
      console.log(res.data.data.user)
      if (Object.keys(res.data.data.user) == 0 || res.data.data.user.length == 0) {
        this.user = {}
        this.user.type = 0
      } else {
        this.disabled = true
        res.data.data.user.team_pic = ''
        this.user = res.data.data.user
        this.user.type = 0
      }
    })
  },
  methods: {
    selectType() {
      console.log(this.user.type)
      let _this = this
      this.num = ''
      if (this.user.type == 0) {
        this.getUserInfo()
      } else {
        this.disabled = false
        this.user = {
          type: _this.user.type,
          name: '',
          tel: '',
          idcard: '',
          team_desc: '',
          team_pic: ''
        }
      }
    },
    getUserInfo() {
      let _this = this
      var type = this.user.type
      this.ajax(`/api/reserve/info?id=${this.$route.query.id}`, 'get', '', res => {
        this.data = res.data.data.data
        console.log(res.data.data.user)
        if (Object.keys(res.data.data.user) == 0 || res.data.data.user.length == 0) {
          this.user = {}
          this.user.type = type
        } else {
          this.disabled = true
          res.data.data.user.team_pic = ''
          this.user = res.data.data.user
          this.user.type = type
        }
      })
    },
    // 提交
    submit() {
      let param = {
        id: this.$route.query.id,
        name: this.user.name,
        idcard: this.user.idcard,
        tel: this.user.tel,
        num: this.num,
        team_desc: this.user.team_desc,
        team_pic: this.user.team_pic,
        idcard_front: this.user.idcard_front,
        idcard_reverse: this.user.idcard_reverse,
        type: this.user.type
      }
      this.ajax('/api/reserve/reserve', 'post', this.$qs.stringify(param), res => {
        this.$alert('预约成功', () => {
          this.$router.go(-1)
        })

      })
    },
    // 上传图片
    upload(e, type) {
      let that = this
      let img = e.target.files[0];
      let param = new FormData()
      param.append('file', img)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$loading.show()
      if (type == "team") {
        this.axios.post('/api/user/image', param, config)
          .then(res => {
            if (res.data.errcode == 0) {
              that.user.team_pic = res.data.data.url
              that.$nextTick(() => {
                that.$loading.hide()
                that.$toast('上传成功')
              })
            } else {
              that.$toast(res.data.errmsg)
            }
          })
      } else {
        this.axios.post('/api/user/idcard', param, config)
          .then(res => {
            if (res.data.errcode == 0) {
              // that.$toast('上传成功')
              that.axios.post('/api/course/realnameVerify', this.$qs.stringify({
                img_url: res.data.data.url
              })).then(result => {
                if (result.data.errcode == 0) {
                  that.user.idcard_front = res.data.data.url
                  that.$nextTick(() => {
                    that.$loading.hide()
                    that.$toast('上传成功')
                  })
                } else {
                  that.$loading.hide()
                  this.$toast(result.data.errmsg)
                }

              })
            } else {
              that.$loading.hide()
              that.$toast(res.data.errmsg)
            }
          })
      }

    },
  },
  components: {

  },
};
</script>

<style scoped>
.container {
  background: #fff;
  padding: 50px;
}

.container > h5 {
  font-size: 1.3em;
  color: #333333;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
}

.cont {
  width: 36.3em;
  margin: 20px auto;
}

.cont > h6 {
  font-size: 1em;
  color: #333;
  font-weight: bold;
  text-align: center;
}

.cont > h6 > span {
  color: #0677e4;
  font-style: italic;
}

.cont > section {
  padding: 30px 74px 0;
}

.cont .btn {
  width: 100%;
  line-height: 45px;
  height: 45px;
}

.field {
  min-height: 60px;
  padding: 5px 0;
}

.field input[type="text"],
.field input[type="number"],
textarea {
  font-size: 1em;
  border: 1px solid #cfcfcf;
  width: 100%;
  line-height: 45px;
  padding: 5px 10px;
  border-radius: 7px;
  height: 45px;
  outline: none;
  color: #a3a3a3;
}

textarea {
  min-height: 9em;
}

.field p {
  color: #666666;
  font-size: 0.9em;
  position: relative;
  margin-bottom: 5px;
}

.field p > span {
  color: red;
}

.field > label {
  font-size: 0.8em;
  color: #b2b2b2;
}

.btn {
  margin-top: 15px;
}

.blue {
  color: #42adff;
}

.idcard {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.idcard p {
  color: #999;
  width: 47%;
  height: 140px;
  border-radius: 7px;
  border: 1px solid #cfcfcf;
  color: #aaaaaa;
  text-align: center;
  line-height: 140px;
  font-size: 1.1em;
  overflow: hidden;
}

.idcard p img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

input[type="file"] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}

@media only screen and (max-width: 750px) {
  .container > h5 {
    font-size: 1em;
    padding-bottom: 0.1rem;
  }

  .cont .item {
    width: 100%;
  }

  .container {
    padding: 0.15rem;
    font-size: 0.14rem;
  }

  .cont {
    width: 100%;
  }

  .cont > section {
    padding: 0 0.15rem;
  }

  .field input[type="text"],
  .field input[type="number"] {
    height: 0.35rem;
    line-height: 0.35rem;
  }

  .idcard p {
    height: 0.8rem;
    line-height: 0.8em;
    overflow: hidden;
  }

  .idcard p a {
    line-height: 0.8rem;
  }
}
</style>